<template>
  <transition name="popup-fade">
    <div v-if="visible && popups.length" class="popup-overlay" @click.self="close">
      <div class="popup-stage">
        <!-- 데스크톱: 가로 나열 -->
        <div class="popup-row desktop-only">
          <component
            v-for="(item, idx) in popups"
            :key="item.id || idx"
            :is="item.link ? 'a' : 'div'"
            :href="item.link || null"
            :target="item.link ? '_blank' : null"
            :rel="item.link ? 'noopener' : null"
            class="popup-item"
          >
            <img :src="item.imageUrl" :alt="item.title || '팝업'" />
          </component>
        </div>

        <!-- 모바일: 스와이프 슬라이더 -->
        <div class="popup-slider mobile-only">
          <div class="slider-viewport"
            @touchstart="onTouchStart"
            @touchmove="onTouchMove"
            @touchend="onTouchEnd"
          >
            <div
              class="slider-track"
              :style="{ transform: `translateX(-${activeIdx * 100}%)` }"
            >
              <component
                v-for="(item, idx) in popups"
                :key="item.id || idx"
                :is="item.link ? 'a' : 'div'"
                :href="item.link || null"
                :target="item.link ? '_blank' : null"
                :rel="item.link ? 'noopener' : null"
                class="slider-slide"
              >
                <img :src="item.imageUrl" :alt="item.title || '팝업'" />
              </component>
            </div>
          </div>

          <!-- 인디케이터 -->
          <div v-if="popups.length > 1" class="indicators">
            <button
              v-for="(_, idx) in popups"
              :key="idx"
              class="indicator-dot"
              :class="{ active: activeIdx === idx }"
              @click="activeIdx = idx"
            />
          </div>
        </div>

        <button class="popup-btn" @click="close">팝업닫기</button>
      </div>
    </div>
  </transition>
</template>

<script>
import { listMedia } from '@/firebase/mediaService'

const STORAGE_KEY = 'iaan-popup-hidden-until'

export default {
  name: 'PopupBanner',
  data() {
    return {
      popups: [],
      visible: false,
      activeIdx: 0,
      touchStartX: 0,
      touchDeltaX: 0
    }
  },
  async mounted() {
    const hiddenUntil = Number(localStorage.getItem(STORAGE_KEY) || 0)
    if (Date.now() < hiddenUntil) return

    try {
      const items = await listMedia('popup')
      this.popups = items.filter(p => p.active !== false && p.imageUrl)
      if (this.popups.length) {
        setTimeout(() => { this.visible = true }, 800)
      }
    } catch (e) {
      console.error('팝업 불러오기 실패', e)
    }
  },
  methods: {
    close() {
      this.visible = false
    },
    closeToday() {
      const tomorrow = new Date()
      tomorrow.setHours(24, 0, 0, 0)
      localStorage.setItem(STORAGE_KEY, String(tomorrow.getTime()))
      this.visible = false
    },
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
      this.touchDeltaX = 0
    },
    onTouchMove(e) {
      this.touchDeltaX = e.touches[0].clientX - this.touchStartX
    },
    onTouchEnd() {
      if (Math.abs(this.touchDeltaX) < 50) return
      if (this.touchDeltaX < 0 && this.activeIdx < this.popups.length - 1) {
        this.activeIdx++
      } else if (this.touchDeltaX > 0 && this.activeIdx > 0) {
        this.activeIdx--
      }
      this.touchDeltaX = 0
    }
  }
}
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  overflow-y: auto;
}

.popup-stage {
  max-width: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
}

/* 데스크톱 */
.popup-row {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
}

.popup-item {
  width: 400px;
  max-width: 90vw;
  display: block;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  line-height: 0;
}

a.popup-item { cursor: pointer; text-decoration: none; }
a.popup-item:hover img { opacity: 0.95; }

.popup-item img {
  width: 100%;
  height: auto;
  display: block;
  transition: opacity 0.2s ease;
}

/* 모바일 슬라이더 */
.popup-slider {
  display: none;
  width: 100%;
  max-width: 400px;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.slider-viewport {
  width: 100%;
  overflow: hidden;
  touch-action: pan-y;
}

.slider-track {
  display: flex;
  width: 100%;
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

.slider-slide {
  flex: 0 0 100%;
  min-width: 0;
  background: #fff;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  line-height: 0;
}

a.slider-slide { cursor: pointer; text-decoration: none; }

.slider-slide img {
  width: 100%;
  height: auto;
  display: block;
}

/* 인디케이터 */
.indicators {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.indicator-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  border: none;
  padding: 0;
  cursor: pointer;
  transition: all 0.25s ease;
}

.indicator-dot.active {
  width: 24px;
  border-radius: 10px;
  background: #fff;
}

/* 닫기 버튼 */
.popup-btn {
  min-width: 180px;
  padding: 14px 36px;
  background: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.7);
  border-radius: 50px;
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: all 0.25s ease;
  letter-spacing: 0.5px;
}

.popup-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: #fff;
}

/* 트랜지션 */
.popup-fade-enter-active,
.popup-fade-leave-active { transition: opacity 0.3s ease; }

.popup-fade-enter-active .popup-item,
.popup-fade-enter-active .slider-slide {
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.popup-fade-enter-from,
.popup-fade-leave-to { opacity: 0; }

.popup-fade-enter-from .popup-item,
.popup-fade-enter-from .slider-slide {
  transform: translateY(30px) scale(0.95);
}

.popup-fade-leave-to .popup-item,
.popup-fade-leave-to .slider-slide {
  transform: translateY(-20px) scale(0.98);
}

/* 데스크톱/모바일 구분 */
.mobile-only { display: none; }
@media (max-width: 768px) {
  .desktop-only { display: none; }
  .mobile-only { display: flex; }

  .popup-overlay {
    padding: 16px;
  }

  .popup-btn {
    width: 100%;
    max-width: 400px;
    font-size: 13px;
    padding: 14px;
  }
}
</style>
